export enum OrgaStructImportMode {
    Unset = 0,
        Default = 1,
        CreateFromImport = 2,
        CreateFromDeadline = 3,
        OverwriteExisiting = 4
}
